import { Typography } from '@euler/app/components/typography';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, ReactNode } from 'react';
import { View } from 'react-native';

export const OrderInfoCell = memo(
  ({
    title,
    titleView,
    detail,
    detailColor,
    note,
    children,
    last,
  }: {
    title?: string;
    titleView?: ReactNode;
    detail?: string;
    detailColor?: string;
    children?: ReactNode;
    checked?: boolean;
    note?: string;
    last?: boolean;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <HStack
        css={`
          border-bottom-width: ${last ? 0 : 1}px;
          border-bottom-color: rgb(241, 241, 241);
          min-height: ${rpx(44)}px;
          margin-left: ${rpx(15)}px;
          padding-right: ${rpx(15)}px;
          padding-top: ${rpx(4)}px;
          padding-bottom: ${rpx(4)}px;
        `}
      >
        {titleView ?? (
          <Typography.Label
            size={rpx(16)}
            color="rgb(102, 102, 102)"
            medium
            css={`
              max-width: 56%;
            `}
          >
            {title ?? ''}
          </Typography.Label>
        )}
        <View
          css={`
            margin-left: ${rpx(15)}px;
            flex: 1;
            align-items: flex-end;
            max-width: 70%;
          `}
        >
          <HStack justifyContent="flex-end">
            {children ?? (
              <Typography.Label
                color={detailColor ?? 'rgb(51, 51, 51)'}
                size={rpx(16)}
                light
                align="right"
              >
                {detail ?? ''}
              </Typography.Label>
            )}
          </HStack>
          {note ? (
            <Typography.Label
              light
              color="#999"
              size={rpx(12)}
              css={`
                margin-top: ${rpx(4)}px;
              `}
            >
              {note}
            </Typography.Label>
          ) : null}
        </View>
      </HStack>
    );
  },
);
